import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Imports ESTÁTICOS de propósito: trocar por `await import()` para usar try/catch
// tiraria react/router/i18next do grafo estático e o .size-limit.js (que mede
// entry + imports estáticos) passaria a medir ~0. Erro de boot é capturado pelo
// handler no index.html.
import { App } from '@/app'
import { bootstrapAuth } from '@/shared/auth/bootstrap'
import '@/shared/config/env' // valida o .env.local e lança se estiver errado
import '@/shared/i18n' // pronto antes do 1º render: sem flash de chave crua
import '@/styles/globals.css'

const root = document.getElementById('root')
if (!root) throw new Error('Elemento #root não encontrado em index.html.')

// Antes do createRoot: a guarda de rota já vê o status final de auth, sem flash
// de "não autenticado". Nunca dentro de useEffect — o StrictMode roda 2x e o
// `code` do callback é de uso único.
await bootstrapAuth()

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
